
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage";
import WebHome from "./components/WebHome";
import WebCompass from "./components/WebCompass";
import WebLogin from "./components/WebLogin";
import WebSignup from "./components/WebSignup"; 
import WebSupport from "./components/WebSupport";
import WebSignupTemp from "./components/WebSignupTemp";

function App() {
  return (
    <Router>
      <Routes>
        {/* Homepage route */}
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<WebHome />} />
        <Route path="/compass" element={<WebCompass />} />  
        <Route path="/login" element={<WebLogin />} />
        <Route path="/support" element={<WebSupport />} />
        <Route path="/signup" element={<WebSignupTemp />} />
        {/* /test route with backend message */}
        
      </Routes>
    </Router>
  );
}

export default App;
